/* eslint-disable @typescript-eslint/naming-convention -- using css conventions */
import { defineSemanticTokens } from '@chakra-ui/react';

export const semanticTokens = {
  colors: defineSemanticTokens.colors({
    bg: {
      DEFAULT: {
        value: { _light: '{colors.white}', _dark: '{colors.white}' },
      },
      subtle: {
        value: { _light: '{colors.gray.50}', _dark: '{colors.gray.50}' },
      },
      panel: {
        value: { _light: '{colors.white}', _dark: '{colors.white}' },
      },
      emphasized: {
        value: { _light: '{colors.gray.200}', _dark: '{colors.gray.200}' },
      },
      muted: {
        value: { _light: '{colors.gray.200}', _dark: '{colors.gray.200}' },
      },
      error: {
        value: { _light: '{colors.red.50}' },
      },
      warning: {
        value: { _light: '{colors.yellow.50}' },
      },
      success: {
        value: { _light: '{colors.on-lime.50}' },
      },
      info: {
        value: { _light: '{colors.blue.50}' },
      },
    },
    // fg is for text or other foreground elements
    fg: {
      DEFAULT: { value: { _light: '{colors.gray.900}', _dark: '{colors.gray.800}' } }, // Formerly chakra-body-text
      muted: { value: { _light: '{colors.gray.600}', _dark: '{colors.gray.600}' } }, // Formerly secondary-text and chakra-placeholder-color
      subtle: { value: { _light: '{colors.gray.25}', _dark: '{colors.gray.25}' } }, // Formerly chakra-body-bg
      error: {
        value: { _light: '{colors.red.600}', _dark: '{colors.red.400}' },
      },
      warning: {
        value: { _light: '{colors.orange.600}' },
      },
      success: {
        value: { _light: '{colors.green.500}' },
      },
      info: {
        value: { _light: '{colors.blue.600}', _dark: '{colors.blue.600}' },
      },
    },
    border: {
      DEFAULT: {
        value: { _light: '{colors.gray.200}', _dark: '{colors.gray.200}' },
      },
    },
    blue: {
      contrast: {
        value: { _light: 'white', _dark: 'white' },
      },
      fg: {
        value: { _light: '{colors.blue.600}', _dark: '{colors.blue.600}' },
      },
      subtle: {
        value: { _light: '{colors.blue.100}', _dark: '{colors.blue.900}' },
      },
      muted: {
        value: { _light: '{colors.blue.200}', _dark: '{colors.blue.800}' },
      },
      emphasized: {
        value: { _light: '{colors.blue.300}', _dark: '{colors.blue.700}' },
      },
      solid: {
        value: { _light: '{colors.blue.500}', _dark: '{colors.blue.500}' },
      },
      focusRing: {
        value: { _light: '{colors.blue.50}', _dark: '{colors.blue.50}' },
      },
    },
    green: {
      fg: { value: { _light: '{colors.green.500}', _dark: '{colors.green.500}' } },
    },
    red: {
      fg: { value: { _light: '{colors.red.600}', _dark: '{colors.red.500}' } },
    },
    orange: {
      fg: { value: { _light: '{colors.orange.600}', _dark: '{colors.orange.500}' } },
    },
    link: {
      DEFAULT: {
        value: { _light: '{colors.blue.600}', _dark: '{colors.link.1}' },
      },
      muted: { value: { _light: '{colors.gray.400}', _dark: '{colors.gray.400}' } },
      subtle: {
        value: { _light: '{colors.gray.50}', _dark: '{colors.link.2}' },
      },
      error: {
        value: { _light: '{colors.red.500}', _dark: '{colors.red.800}' },
      },
      info: {
        value: { _light: '{colors.blue.600}', _dark: '{colors.link.1}' },
      },
    },
    gray: {
      fg: { value: { _light: '{colors.gray.900}', _dark: '{colors.gray.800}' } },
    },
  }),

  shadows: defineSemanticTokens.shadows({
    md: {
      value: {
        _light: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
        _dark: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
      },
    },
    sm: {
      value: {
        _light: '0px 2px 4px {colors.gray.900/10}, 0px 0px 1px {colors.gray.900/30}',
        _dark: '0px 2px 8px {colors.gray.800/10}, 0px 0px 1px {colors.gray.900/30}',
      },
    },
    pinnedLeft: { value: { _light: '2px 0px 2px 0px rgba(0, 0, 0, 0.1)' } },
  }),
};
